var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mainWrapper",staticClass:"lxn-h100 lxn-w100 lxn-pos-rel"},[(!_vm.hideCurve)?_c('CustomCurve',[_c('div',{staticClass:"CurveWithSvg-default-slot-wrapper lxn-w100 lxn-pos-rel"},[_vm._t("default")],2)]):_vm._e(),_c('div',{staticClass:"CurveWithSvg-wrapper-svg lxn-w100 lxn-pos-abs",style:(_vm.svgHeight)},[_vm._t("svg")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }